import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { ManageDashboardViewSpocsRPC } from "./manageDashboardViewSpocsRPC";

export class ManageDashboardViewSpocsRPCClientImpl extends ManageDashboardViewSpocsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: ManageDashboardViewSpocsRPC.Request): Promise<LeoRPCResult<ManageDashboardViewSpocsRPC.Response, ManageDashboardViewSpocsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-dashboard/ManageDashboardViewSpocs",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      ManageDashboardViewSpocsRPC.ResponseDTO,
      ManageDashboardViewSpocsRPC.Errors.ErrorsDTO,
      ManageDashboardViewSpocsRPC.Response,
      ManageDashboardViewSpocsRPC.Errors.Errors
    >(
      response,
      "survey-dashboard/ManageDashboardViewSpocs",
      ManageDashboardViewSpocsRPC.Response.fromDTO,
      ManageDashboardViewSpocsRPC.Errors.fromDTO
    );
  }
}
